<template><div class="date-select">
  <select v-model="year">
    <option disabled></option>
    <option v-for="y in years" :key="'year-'+y"
      :value="y" v-html="y" />
  </select>
  <select v-model="month">
    <option v-for="m in months" :key="'month-'+m"
      :value="m" v-html="mt[m]" />
  </select>
  <select v-model="date">
    <option v-for="d in dates" :key="'date-'+d"
      :value="d" v-html="d" />
  </select>
</div></template>
<script>
import moment from 'moment'
export default {
  name: 'date-select',
  props: ['min','max','value'],
  data() {
    let d = this.parseValue(this.value)
    d.mt = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
    return d
  },
  computed: {
    _min() {
      let m = moment().subtract(5, 'years').startOf('year')
      return moment.isMoment(this.min) ? moment.max(m, this.min) : m
    },
    _max() {
      let m = moment().add(7, 'days').endOf('day')
      return moment.isMoment(this.max) ? moment.min(m, this.max) : m
    },
    years() {
      let yy = []
      for (let d = this._min.clone(); d.isBefore(this._max); d.add(1, 'year'))
        yy.push(d.year())
      if (this._max.year() !== yy[yy.length-1])
        yy.push(this._max.year())
      return yy
    },
    months() {
      let mm = []
      if (moment.isMoment(this.value) && !this._min.isAfter(this._max)) {
        let yearStart = moment([this.year]),
          yearEnd = moment.min(yearStart.clone().endOf('year'), this._max).clone(),
          d = moment.max(yearStart, this._min).clone().startOf('month')
        while (!d.isAfter(yearEnd)) {
          mm.push(d.month())
          d = d.add(1, 'month')
        }
      }
      return mm
    },
    dates() {
      let dd = []
      let cnt = 0
      if (moment.isMoment(this.value) && !this._min.isAfter(this._max)) {
        let monthStart = moment([this.year, this.month]),
          monthEnd = moment.min(monthStart.clone().endOf('month'), this._max).clone(),
          d = moment.max(monthStart, this._min).clone().startOf('day')
        while (!d.isAfter(monthEnd) && ++cnt < 50) {
          dd.push(d.date())
          d = d.add(1, 'day')
        }
      }
      return dd
    },
  },
  watch: {
    value(nv,ov) { Object.assign(this, this.parseValue()) },
    year(nv,ov) { this.updateDate('year', nv) },
    month(nv,ov) { this.updateDate('month', nv) },
    date(nv,ov) { this.updateDate('date', nv) },
    months(nv) {
      if (!nv.length) return
      if (this.month < nv[0]) this.month = nv[0]
      else if (this.month > nv[nv.length-1]) this.month = nv[nv.length-1]
    },
    dates(nv) {
      if (!nv.length) return
      if (this.date < nv[0]) this.date = nv[0]
      else if (this.date > nv[nv.length-1]) this.date = nv[nv.length-1]
    },
  },
  methods: {
    parseValue(m) {
      return (
        moment.isMoment(this.value)
          ? { year: this.value.year(), month: this.value.month(), date: this.value.date() }
          : { year: null, month: null, date: null }
      )
    },
    updateDate(attr, val) {
      if (!moment.isMoment(this.value)) return
      this.$emit('input', this.value.clone()[attr](val))
    },
  },
}
</script>
<style lang="scss">
.date-select {
  margin-bottom: 5px;
  select { margin-right: 5px; }
}
</style>
